import { connect } from 'react-redux';
import FiltersContainer from './filters_container';

const mapStateProps = ({ application, user }) => ({
  newToPG: application.newToPG,
  lastPurchaseDate: ((user || {}).user || {}).lastPurchaseDate,
  localFilterPricePerMinute: application?.dynamicConfig?.localFilterPricePerMinute,
  currency: application?.dynamicConfig?.currency
});

export default connect(mapStateProps)(FiltersContainer);
